import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Components

import ModalHeader from '@common-components/headers/ModalHeader';

const MarriageModal = props => {

    let {
        actions: {
            hideModal
        },
        bottomAnchors: [
            anchor_1,
        ],
        boundAnchor,
        modal: {
            modalData: {
                records,
                lce,
                callbacks: [
                    updateRecords,
                    changeItemStatus
                ]
            }
        },
        modalHeaderProps
    } = props;



    const handleHideClick = () => {
        changeItemStatus();
        hideModal();
    };

    const handleSaveClick = () => {
        records = [
            ...records,
            lce
        ];
        updateRecords(records);
        changeItemStatus();
        handleHideClick();
    };

    return (
        <Fragment>
            <ModalHeader { ...modalHeaderProps } />
            <div id="lceMarriageModal" className="usa-grid">
                <div className="modal__body">
                    <FormattedMessage id='modals.marriage.content'/>
                </div>
            </div>
            <div className="modal__footer">
                <div className='usa-grid controls'>
                    <div className='usa-offset-one-third txt-left'>
                        <Button
                            className='usa-button usa-button--outline gi-button gi-button__outline'
                            onClick={handleHideClick}
                        >
                            Cancel
                        </Button>
                        <Button
                            className='usa-button gi-button gi-button__primary'
                            onClick={handleSaveClick}
                            inputRef={boundAnchor(anchor_1)}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>

        </Fragment>
    );
};

export default MarriageModal;
